document.addEventListener("d365mkt-afterformsubmit", function () {
	removeLoadingBar();
	$('.dataprotection').addClass('hidden');
});

document.addEventListener("d365mkt-afterformload", function () {
	console.log('afterFormLoad');
	
	const todayDate = new Date();
	
	if(document.getElementById("c781f1fc-0b8d-ed11-81ad-0022481b5bd0")){
		document.getElementById("c781f1fc-0b8d-ed11-81ad-0022481b5bd0").value = todayDate.toISOString().slice(0, -8);
	}

	if(document.getElementById("py3_bulkemailconsent-1712752767486")){
		document.getElementById("py3_bulkemailconsent-1712752767486").value = todayDate.toISOString().slice(0, -8);
	}

	//UTM Parameters
	let query = new URLSearchParams(document.location.search);
	if (document.getElementById("8a60cbb2-650f-ee11-8f6e-002248c65cbe")) {
		document.getElementById("8a60cbb2-650f-ee11-8f6e-002248c65cbe").value = document.referrer;
	}
	if (document.getElementById("4df5c77f-640f-ee11-8f6e-002248c65cbe")) {
		document.getElementById("4df5c77f-640f-ee11-8f6e-002248c65cbe").value = query.get("utm_source");
	}
	if (document.getElementById("d9c4d0b4-680f-ee11-8f6e-002248c65cbe")) {
		document.getElementById("d9c4d0b4-680f-ee11-8f6e-002248c65cbe").value = query.get("utm_source");
	}
	if (document.getElementById("08f86e8e-650f-ee11-8f6e-002248c65cbe")) {
		document.getElementById("08f86e8e-650f-ee11-8f6e-002248c65cbe").value = query.get("utm_medium");
	}
	if (document.getElementById("7fc09aa0-650f-ee11-8f6e-002248c65cbe")) {
		document.getElementById("7fc09aa0-650f-ee11-8f6e-002248c65cbe").value = query.get("utm_campaign");
	}
	if (document.getElementById("fee497a6-650f-ee11-8f6e-002248c65cbe")) {
		document.getElementById("fee497a6-650f-ee11-8f6e-002248c65cbe").value = query.get("utm_content");
	}

	//Check membership communications
	if (document.getElementById("87671ca2-334b-ee11-be6f-002248c651e3")) {
		//If input is not checked, hide the sign up
		if (!document.getElementById("87671ca2-334b-ee11-be6f-002248c651e3").checked) {
			document.getElementById("87671ca2-334b-ee11-be6f-002248c651e3").parentElement.parentElement.parentElement.parentElement.style.display = "none";
		}
	}

	$(document).on('click', '.marketingForm input[type="text"], .marketingForm input[type="email"]', function (e) {
		var statement = $('.dataprotectionstatementSource').html();
		$('.dataprotectionstatement').html('<div class="w-full text-white dataprotection text-xs 2xl:text-sm leading-tight text-center"><div class="hidden sm:block">' + statement + '</div><div class="block sm:hidden"><p>By signing up you agree to our <a href="/privacy-policy#data-protection-statement">Data Protection Statement</a></p></div></div>')
		$('.dataprotection').removeClass('hidden');
	});
	

	//Make global signup appear only after load
	//$('.signup').addClass('sm:fixed');
});

/*
$(function () {
	$(document).on('change','#7f685ebb-7c54-4cff-a1bc-772562d25c38', function () {
		this.value = $.trim(this.value);
	});
});

MsCrmMkt.MsCrmFormLoader.on('formSubmit', function (event) {
	// sample validation - check if email valid
	var dynamicsEmail = document.getElementById('7f685ebb-7c54-4cff-a1bc-772562d25c38').value;

	if (!isEmail(dynamicsEmail)) {
		event.preventDefault();
	}
});*/